/* global Vimeo */

let hasLoaded = false;

const createPlayer = (target, id, title, height, width, errorHandler) => {
  if (Vimeo) {
    hasLoaded = true;

    const player = new Vimeo.Player(target, { id, height, width });

    player.ready().then(() => {
      const iframe = target.querySelector("iframe");
      iframe.title = `Vimeo player: ${title} video`;
      iframe.focus();
    });

    player.play().catch((error) => {
      if (errorHandler) {
        errorHandler(error);
      }
    });
  } else {
    alert("NO VIMEO");
  }
};

const loadVimeoVideoPlayer = (
  target,
  videoId,
  title,
  height,
  width,
  errorHandler
) => {
  if (hasLoaded) {
    createPlayer(target, videoId, title, height, width, errorHandler);

    return;
  }

  const script = document.createElement("script");

  script.onload = () =>
    createPlayer(target, videoId, title, height, width, errorHandler);

  script.src = "https://player.vimeo.com/api/player.js";

  document.head.appendChild(script);
};

export default loadVimeoVideoPlayer;
